<template>
  <div>
    <HeadBar /><!--顶部bar-->
    <!--顶部logo、检索-->
    <HeadNav /><!-- 顶部导航-->
    <div class="detail" v-loading="loading">
      <div class="detail-inner">
        <div class="detail-path">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ name: 'onlineTrain' }"
              >列表</el-breadcrumb-item
            >
            <el-breadcrumb-item>详情</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <Brief :data="detail" />
        <Introduce :data="detail" />
      </div>
    </div>
    <FootBar />
  </div>
</template>
<script>
import Brief from "./components/Brief.vue";
import Introduce from "./components/Introduce.vue";
import { trainDetail } from "@/api/onlineTrain";
export default {
  components: {
    Brief,
    Introduce,
  },
  data() {
    return {
      id: null,
      detail: {},
      loading: false,
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.getDetail();
  },
  methods: {
    async getDetail() {
      this.loading = true;
      const data = await this.$axios
        .get(trainDetail, { id: this.id })
        .finally(() => {
          this.loading = false;
        });
      this.detail = data;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/variable";
.detail {
  padding: 20px 0;
  background: $home-bg;
  &-inner {
    width: $max-width;
    margin: 0 auto;
  }
  &-path {
    margin-bottom: 10px;
  }
}
</style>
